import {
  getThemeClass,
  getThemeComponentClasses,
} from "@/src_new/shared/lib/themeComponentClasses";

type AuthDeliveryOptionsProps = {
  hasPhoneOption: boolean;
  hasEmailOption: boolean;
  activeMethod: "email" | "phone";
  onChange: (value: "email" | "phone") => void;
  disabled?: boolean;
  phoneLabel?: string;
  emailLabel?: string;
};

export default function AuthDeliveryOptions({
  hasPhoneOption,
  hasEmailOption,
  activeMethod,
  onChange,
  disabled,
  phoneLabel,
  emailLabel,
}: AuthDeliveryOptionsProps) {
  const inputClasses = getThemeComponentClasses().input;

  return (
    <div className="space-y-2">
      <p className="text-sm font-semibold text-theme-text-muted">Choose where to receive OTP</p>

      {hasPhoneOption ? (
        <label
          className={`flex items-start gap-3 rounded-lg border px-3 py-2 cursor-pointer ${getThemeClass(inputClasses.borderColor, "border-theme-border")}`}
        >
          <input
            type="radio"
            checked={activeMethod === "phone"}
            onChange={() => onChange("phone")}
            disabled={disabled}
          />
          <span className="text-sm text-theme-text-muted">{phoneLabel}</span>
        </label>
      ) : null}

      {hasEmailOption ? (
        <label
          className={`flex items-start gap-3 rounded-lg border px-3 py-2 cursor-pointer ${getThemeClass(inputClasses.borderColor, "border-theme-border")}`}
        >
          <input
            type="radio"
            checked={activeMethod === "email"}
            onChange={() => onChange("email")}
            disabled={disabled}
          />
          <span className="text-sm text-theme-text-muted">{emailLabel}</span>
        </label>
      ) : null}
    </div>
  );
}
